// extracted by mini-css-extract-plugin
module.exports = {"iframe-wrapper":"Iframe_iframe-wrapper__1Hb_s","has-modal":"Iframe_has-modal__2BFH9","has-height":"Iframe_has-height__aTZNe","modal-dialog":"Iframe_modal-dialog__2wLcQ"};